import Image from 'next/image'
import styled from 'styled-components'
import aiEditImage from '../../../assets/ai-studio-landing/ai_edit.png'
import aiRefineImage from '../../../assets/ai-studio-landing/ai_refine.png'

const SectionWrapper = styled.section`
  width: 100%;
  padding: 80px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 60px 20px;
  }
`

const SectionTitle = styled.h2`
  color: black;
  font-size: 48px;
  font-weight: 500;
  text-align: center;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 32px;
  }
`

const SectionSubtitle = styled.p`
  color: #3F3F3F;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  margin: 0;
  max-width: 900px;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`

const CardsContainer = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
  max-width: 1200px;
  margin-top: 26px;

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: center;
  }
`

const FeatureCard = styled.div`
  flex: 1;
  max-width: 590px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  @media (max-width: 1024px) {
    max-width: 100%;
    width: 100%;
  }
`

const CardVisual = styled.div`
  width: 100%;
  height: 413px;
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  background: #f5f5f5;

  @media (max-width: 768px) {
    height: 280px;
  }
`

const CardTitle = styled.h3`
  color: black;
  font-size: 24px;
  font-weight: 500;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`

const CardDescription = styled.p`
  color: #545454;
  font-size: 18px;
  font-weight: 400;
  margin: 0;
  line-height: 1.5;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`

const ActionButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 178px;
  height: 44px;
  background: linear-gradient(270deg, #FF996E 0%, #FF5565 37%, #FF4576 75%, #FF5E84 100%);
  border-radius: 100px;
  color: white;
  font-size: 18px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  margin-top: 6px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 768px) {
    width: 100%;
    max-width: 200px;
  }
`

const MoreWaysSection = ({ onActionClick }) => {
  return (
    <SectionWrapper>
      <SectionTitle>More Ways to Design with AI.</SectionTitle>
      <SectionSubtitle>
        Make precise changes, fine-tune details, and elevate your designs with AI tools built for real control — not one-click redesigns.
      </SectionSubtitle>

      <CardsContainer>
        <FeatureCard>
          <CardVisual>
            <Image
              src={aiEditImage}
              alt="AI Edit Your Room"
              layout="fill"
              objectFit="cover"
            />
          </CardVisual>
          <CardTitle>AI Edit Your Room</CardTitle>
          <CardDescription>
            Edit specific areas or items in your room with AI. Instantly remove, replace, or swap furniture, décor, colors, or materials — without redesigning the entire space.
          </CardDescription>
          <ActionButton onClick={onActionClick}>Edit with AI</ActionButton>
        </FeatureCard>

        <FeatureCard>
          <CardVisual>
            <Image
              src={aiRefineImage}
              alt="AI Refine Your Design"
              layout="fill"
              objectFit="cover"
            />
          </CardVisual>
          <CardTitle>AI Refine Your Design</CardTitle>
          <CardDescription>
            With one tap, refine lighting, layout, realism, and balance to transform a good design into a polished, professional interior.
          </CardDescription>
          <ActionButton onClick={onActionClick}>Refine with AI</ActionButton>
        </FeatureCard>
      </CardsContainer>
    </SectionWrapper>
  )
}

export default MoreWaysSection
